import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { ReportProductionGerentePDF } from "./Components/PDF/ReportProductionGerentePDF";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";

import { DrawerFilterProductionGerente } from "./Components/DrawerFilter/DrawerFilterProductionGerente";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportProductionGerente = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportProductionGerente } = useContextReportsProduction();

  const hasData = !!listReportProductionGerente?.data?.length;

  return (
    <>
      <CardHeaderCore
        buttonAdd={[<DrawerFilterProductionGerente key="filter" />]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de produção por gerente com filtros personalizados"
        title="Relatório de produção por gerente"
      />

      <ReportProductionGerentePDF />

      {!hasData && !loadingGravar && (
        <NoEmptyPdfCore />
      )}
    </>
  );
};
